<template>
  <BasicLayout :left='left' :middle='middle' :right='right'>
    <template v-slot:right_view>
      <div class='h100vh-100'>
        <BlockingRuleTableButton @notice='notice'></BlockingRuleTableButton>
        <BlockingRuleTable ref='ruleTable'></BlockingRuleTable>
      </div>
    </template>
  </BasicLayout>
</template>

<script>
import BasicLayout from '../../layouts/BasicLayout';
import BlockingRuleTableButton from '../../components/alarmconfig/blockingRule/BlockingRuleTableButton';
import BlockingRuleTable from '../../components/alarmconfig/blockingRule/BlockingRuleTable';

export default {
  name: 'BlockingRulePage',
  components: {
    BasicLayout,
    BlockingRuleTableButton,
    BlockingRuleTable
  },
  data() {
    return {
      left: {
        show: false,
        name: ''
      },
      middle: {
        show: false,
        name: ''
      },
      right: {
        show: true,
        crumb: `${this.$t('Alarm.alarmManage')}/${this.$t('Alarm.blockingRule')}`
      }
    };
  },
  methods: {
    notice(type) {
      switch (type) {
        case 'add':
          this.$refs.ruleTable.addFunc();
          break;
        case 'remove':
          this.$refs.ruleTable.removeFunc();
          break;
        case 'edit':
          this.$refs.ruleTable.editFunc();
          break;
        case 'refresh':
          this.$refs.ruleTable.getBlockingRuleData();
          break;
        case 'able':
          this.$refs.ruleTable.updateStatusFunc('enable');
          break;
        case 'disable':
          this.$refs.ruleTable.updateStatusFunc('unenable');
          break;
        default:
      }
    }
  }
};
</script>